import React, { FC } from "react";
import { Routes, Route } from "react-router-dom";
import AdminMain from "./AdminMain";

const AdminRoutes: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<AdminMain />} />
    </Routes>
  );
};

export default AdminRoutes;
